import { useApiQuery } from 'grabbitbot-legacy-ui'
import { paymentReads } from '../../api/fee'
import { PageTitle, QueryState } from '../../components/common'
import { TransactionTable } from '../../components/payment'
import { useProject } from '../../layout/projectContext'

/** Port of `PaymentTransactionListComponent`
 * (`projects/:projectId/payment/transactions`): the caller's own payment
 * transactions (the legacy page also fetched `…/transactions/statistics`
 * but its chart was commented out — not fetched here). */
export function PaymentTransactionsPage() {
  const { projectId } = useProject()
  const q = useApiQuery(() => paymentReads.transactions(projectId), [projectId])
  return (
    <div className="portal-card">
      <PageTitle title="Transactions" />
      <QueryState loading={q.loading} error={q.error}>
        <TransactionTable rows={q.data ?? []} />
        {q.data?.length === 0 && <p className="portal-text-muted">No transactions yet.</p>}
      </QueryState>
    </div>
  )
}
